import {makeTagToUrl} from '@yandex-delivery/tag-to-url'

export const tagToUrl = makeTagToUrl({host: 'https://ya-authproxy.taxi.yandex.ru'})
